import React from 'react'
import { useParams } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import CampaignInfluencerSidebarNavBase from '../../../../../Shared/CampaignInfluencerSidebar/CampaignInfluencerSidebarNavBase'


export default observer(function CampaignInfluencerSidebarNav({ camp_auth_id }) {
  const {id, campaign_authentication_id } = useParams()
  const basePath = `/advertiser/campaign_share/${id}/influencers/campaign_authentications/${campaign_authentication_id}`
  const links = [
    { key: 'profile', text: 'Profile', href: `${basePath}/profile` },
    { key: 'client_thread', text: 'Client thread', href: `${basePath}/client_thread` },
    { key: 'authentication', text: 'Authentication', href: `${basePath}/authentication` },
  ]

  return (
    <CampaignInfluencerSidebarNavBase links={links} />
  )
})
